import React from 'react';
import { Link, useLocation } from 'react-router';

interface SidebarLinkProps {
  // Internal route (react-router). When set, the link is active on an exact path match.
  to?: string;
  // External / placeholder anchor (used for not-yet-wired items).
  href?: string;
  children: React.ReactNode;
}

export default function SidebarLink({ to, href, children }: SidebarLinkProps) {
  const location = useLocation();

  const className = (active: boolean) =>
    `dash-nav-link flex items-center gap-3 px-6 py-2.5 text-sm font-medium${
      active ? ' dash-nav-link--active' : ''
    }`;

  if (to) {
    // Root "/" is exact-only; other routes use prefix match so nested paths highlight the parent.
    // Use `+ '/'` separator to avoid matching sibling routes (e.g. /orders vs /orders-history).
    const active =
      to === '/'
        ? location.pathname === '/'
        : location.pathname === to || location.pathname.startsWith(to + '/');
    return (
      <Link to={to} className={className(active)}>
        {active && <span className="dash-nav-link__active-bar" />}
        {children}
      </Link>
    );
  }

  return (
    <a href={href ?? '#'} className={className(false)}>
      {children}
    </a>
  );
}
